import intlTelInput from 'intl-tel-input/intlTelInputWithUtils';

export function phoneNumberFormatter({ inputId, phoneAttributeName, countryOrder = ['fr'] }) {
  const input = document.querySelector(inputId);

  const iti = intlTelInput(input, {
    countryOrder,
    formatOnDisplay: true,
    hiddenInput: () => ({ phone: phoneAttributeName }),
    initialCountry: 'fr',
    nationalMode: false,
    separateDialCode: true,
  });

  // On focus loss -> validate
  input.addEventListener('blur', () => {
    if (!input.value.trim()) return;

    input.classList.toggle('is-invalid', !iti.isValidNumber());
  });
}
